import CarNoSidebarContainer from "../../../components/car/grid/CarNoSidebar";

const CarNoSidebar = () => {
  return <CarNoSidebarContainer />;
};

export default CarNoSidebar;
